/**
 * Each program's official MSU Denver page. The Hub links here wherever it
 * describes a program, and for a program that is not taking applications
 * through the Hub this term it is where people go instead.
 *
 * A client constant rather than a ProgramConfig field: the signed-out pages
 * need the links before any request answers, and the pages belong to the
 * university, not to the Hub's per-program settings.
 */
export const PROGRAM_PAGE_URLS = {
    la: 'https://www.msudenver.edu/learning-assistant-program/',
    si: 'https://www.msudenver.edu/student-academic-services/supplemental-instruction/',
    ta: 'https://www.msudenver.edu/student-academic-services/teaching-assistant-program/',
};

/**
 * Whether a program's window verdict (one entry of
 * `term.applicationWindows`) is the program being switched off for the term,
 * as opposed to a window that has not opened or has closed.
 *
 * @param {object|undefined} verdict
 * @returns {boolean}
 */
export const isSwitchedOff = (verdict) => verdict?.reason === 'inactive';
